import { render, staticRenderFns } from "./DashCardsContainer.vue?vue&type=template&id=42731864&scoped=true&"
import script from "./DashCardsContainer.vue?vue&type=script&lang=js&"
export * from "./DashCardsContainer.vue?vue&type=script&lang=js&"
import style0 from "./DashCardsContainer.vue?vue&type=style&index=0&id=42731864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42731864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VMain } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCol,VContainer,VMain,VRow})
